import {connect} from 'react-redux';
import Team from './team';

export const mapStateToProps = (state) => {
  return {
    id: state.auth.userId,
    token: state.auth.token,
  };
};

const TeamContainer = connect(mapStateToProps, null)(Team);

export default TeamContainer;
